import { isAxiosError } from 'axios';
import { z } from 'zod';

const briefsBoardExistsSchema = z.object({ code: z.literal('tracker_briefs_board_exists') });

/** The server refused a tracker because its workspace already has the one briefs board. */
export function isBriefsBoardExistsError(error: unknown): boolean {
  return isAxiosError(error) && briefsBoardExistsSchema.safeParse(error.response?.data).success;
}
